const procedimentos = {
  fatorAcomodacao: 200,
  fatorAuxiliar1: 30,
  fatorAuxiliar2: 20,
  fatorAuxiliar3: 20,
  fatorAuxiliar4: 20,
  fatorCirurgiao: 100,
  fatorUrgencia: 130,
  fatorViaUnica: 50,
  fatorViaSeparada: 70,

  fatorCustoOperacional: '',
  fator: '',
  prazoRecebimento: '',
  quantidadedMesPrazoCompetencia: '',

  tipoPrazo: null,
}

const procedimentosGroups = [
  {
    name: 'Consultas e procedimentos clínicos',
    id: 0,
    groups: [1, 2],
    newItems: 0,
  },
  {
    name: 'Procedimentos cirurgicos',
    id: 1,
    groups: [3],
    newItems: 0,
  },
  {
    name: 'Procedimentos diagnósticos e terapeuticos',
    id: 2,
    groups: [4],
    newItems: 0,
  },
]

export default {
  procedimentos,
  procedimentosGroups,
}
